import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyCh86p6iqI3WVfR_HmxW5IWdb4YcYuCRdw",
  authDomain: "sfitstock-16086.firebaseapp.com",
  projectId: "sfitstock-16086",
  storageBucket: "sfitstock-16086.firebasestorage.app",
  messagingSenderId: "367442148499",
  appId: "1:367442148499:web:2d26e26d768c7ac3f7a166",
  measurementId: "G-6CBZ40ZK98"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const storage = getStorage(app);

export { storage }